export default __webpack_public_path__ + "71cf023363966d03417fc13a6656d7ef.png";